import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../landingPage/home.module.css';

function TermsAndConditions() {
  return (
    <>
      {/* Header */}
      <section className={`${styles.header} ${styles.headerCs}`}>
        <div className={`container ${styles.container}`}>
          <div className={styles.logo}>
            <Link to="/">
              <img src={window.getPublicUrl("/images/logo-2.svg")} alt="ResuMate Logo" />
            </Link>
          </div>
          <div className={styles.social}>
             <ul className='terms-list'>
              <li><a href=""><img src={window.getPublicUrl("/images/insta.svg")} alt="Instagram" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/fb.svg")} alt="Facebook" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/tik.svg")} alt="TikTok" /></a></li>
            </ul>
          </div>
        </div>
      </section>

    <main className="terms-container faq  terms-nd-condition my-3">
      <div  className={`container ${styles.container}`}>
      <header className="terms-header">
        <h1 className='main-heading text-left'>ResuMate Terms and Conditions of Use</h1>
        <p>Last Updated: January 3, 2026</p>
        <p>
          Welcome to ResuMate. These Terms and Conditions (“Terms”) govern your access to and use of
          the ResuMate mobile application and related services (the “App”). By creating an account or
          using the App, you agree to be bound by these Terms. If you do not agree, do not use the App.
        </p>
      </header>

      <article>
        <h2 className='inner-heading'>1. Eligibility</h2>
         <ul className='terms-list'>
          <li>You must be at least 18 years old to use ResuMate.</li>
          <li>By using the App, you represent and warrant that you are legally permitted to enter into this agreement.</li>
          <li>You agree to provide accurate, current, and truthful information and to keep your account information up to date.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>2. Account Registration and Security</h2>
         <ul className='terms-list'>
          <li>To use Resumate, you must create an account with a valid email, phone number, and other required details.</li>
          <li>You are responsible for maintaining the confidentiality of your login credentials and for all activity that occurs under your account.</li>
          <li>You agree to notify ResuMate immediately of any unauthorized access or suspected security breach.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>3. User Profiles and Resume Content (User-Generated Content)</h2>
         <ul className='terms-list'>
          <li>ResuMate allows users to create a profile and a values-based "resume" containing personal details and open-ended responses.</li>
          <li>You are solely responsible for the content you submit, including its accuracy, legality, and appropriateness.</li>
          <li>You must not include sensitive information (financial details, home addresses, government IDs, etc.).</li>
          <li>You retain ownership of your content. By using the App, you grant ResuMate a limited, non-exclusive, royalty-free license to host, use, display, process, and analyze your content solely for operating, improving, and providing the App.</li>
          <li>ResuMate does not endorse, verify, or guarantee the accuracy of user content and is not responsible for it.</li>
          <li>Certain features of the App may use artificial intelligence or automated tools to summarize or analyze user-provided information. ResuMate does not guarantee the accuracy, completeness, or suitability of AI-generated outputs, which are provided for informational purposes only.</li>
          <li>ResuMate reserves the right to remove or restrict content that violates these Terms, Community Guidelines, or applicable law.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>4. Matching, Resume Submissions, and Interactions</h2>
         <ul className='terms-list'>
          <li>ResuMate does not use swiping. Users may send and receive resumes for consideration.</li>
          <li>A private chat feature is enabled only after both users review resumes, complete a video call, and mutually agree to connect.</li>
          <li>You agree to communicate respectfully and to use the App only for lawful, personal, and non-commercial purposes.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>5. Prohibited Conduct</h2>
        <p>When using Resumate, you agree not to:</p>
         <ul className='terms-list'>
          <li>Use the App for any purpose other than personal, non-commercial use.</li>
          <li>Misrepresent your identity or impersonate another person, or provide false information.</li>
          <li>Promote or encourage illegal activity, self-harm, hate speech, threats, abuse, or harassment.</li>
          <li>Upload, transmit, or share content containing curse words, slurs, hateful language, sexually explicit, pornographic, violent, or otherwise offensive material.</li>
          <li>Engage in scams, fraud, spam, or deceptive practices.</li>
          <li>Interfere with, disrupt, or attempt to compromise the security, integrity, or proper functioning of the App, its services, or its network.</li>
          <li>Engage in any other behavior that violates our Community Guidelines or undermines the safety of the Resumate community.</li>
        </ul>
        <p>
          ResuMate does not pre-screen all user communications or content and is not liable for user-generated language, including offensive, inappropriate, or objectionable words. ResuMate may, but is not obligated to, remove such content. ResuMate has no obligation to monitor user activity or content and does not assume responsibility for such activity or content. Users may report violations, and ResuMate reserves the right to remove content or take enforcement action at its discretion.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>6. Premium Features and Payments</h2>
         <ul className='terms-list'>
          <li>ResuMate may offer optional paid features, such as advanced filters or profile boosts.</li>
          <li>All payments are processed through third-party platforms (e.g., Apple App Store or Google Play).</li>
          <li>Fees are non-refundable except as required by applicable law or platform policies.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>7. Safety, Video Calls, and Real-World Interactions</h2>
        <p>ResuMate is designed with safety-forward features, including a required video call prior to enabling private chat. However:</p>
         <ul className='terms-list'>
          <li>You are solely responsible for your interactions with other users, both online and offline.</li>
          <li>ResuMate does not conduct criminal background checks, identity verification, or user screening, except for optional in-app features explicitly described.</li>
          <li>Any interactions that occur outside of the App, including but not limited to in-person meetings, dates, or communications, are entirely between users and undertaken at their own risk.</li>
          <li>You agree to use your own judgment, discretion, and personal safety precautions when interacting with others, both online and offline.</li>
          <li>ResuMate does not provide relationship, psychological, legal, or professional advice. Any decisions you make based on information obtained through the App are made at your own discretion and risk.</li>
          <li>ResuMate is not responsible or liable for the conduct of any user or for any injury, harm, loss, damages, or disputes arising from interactions between users outside the App.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>8. Intellectual Property</h2>
         <ul className='terms-list'>
          <li>All rights, title, and interest in the App, including its design, features, trademarks, and underlying technology, are owned by ResuMate or its licensors.</li>
          <li>You may not copy, modify, distribute, sell, lease, or reverse-engineer any part of the App.</li>
          <li>You retain ownership of the content you create (e.g., profile responses, uploaded photos), but you grant Resumate a limited license to use it for providing the service.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>9. Account Termination</h2>
         <ul className='terms-list'>
          <li>You may delete your account at any time through the App.</li>
          <li>ResuMate may suspend or terminate your account if you violate these Terms, Community Guidelines, or applicable law.</li>
          <li>Termination may result in loss of access to your account and associated data.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>10. Disclaimer of Warranties and Limitation of Liability</h2>
         <ul className='terms-list'>
          <li>The App is provided on an "as is" and "as available" basis without warranties of any kind (“resume”) with personal details, preferences, and open-ended responses.</li>
          <li>You are solely responsible for the content you submit, including its accuracy, legality, and appropriateness.</li>
          <li>You must not include sensitive information (financial details, home addresses, government IDs, etc.).</li>
          <li>You retain ownership of your content. By using the App, you grant ResuMate a limited, non-exclusive, royalty-free license to host, use, display, process, and analyze your content solely for operating, improving, and providing the App.</li>
          <li>ResuMate does not endorse, verify, or guarantee the accuracy of user content and is not responsible for it.</li>
          <li>Certain features of the App may use artificial intelligence or automated tools to summarize or analyze user-provided information. ResuMate does not guarantee the accuracy, completeness, or suitability of AI-generated outputs, which are provided for informational purposes only.</li>
          <li>ResuMate reserves the right to remove or restrict content that violates these Terms, Community Guidelines, or applicable law.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>4. Matching, Resume Submissions, and Interactions</h2>
         <ul className='terms-list'>
          <li>ResuMate does not use swiping. Users may send and receive resumes for consideration.</li>
          <li>A private chat feature is enabled only after both users review resumes, complete a video call, and mutually agree to connect.</li>
          <li>You agree to communicate respectfully and to use the App only for lawful, personal, and non-commercial purposes.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>5. Prohibited Conduct</h2>
        <p>When using Resumate, you agree not to:</p>
         <ul className='terms-list'>
          <li>Use the App for any purpose other than personal, non-commercial use.</li>
          <li>Misrepresent your identity or impersonate another person, or provide false information.</li>
          <li>Promote or encourage illegal activity, self-harm, hate speech, threats, abuse, or harassment.</li>
          <li>Upload, transmit, or share content containing curse words, slurs, hateful language, sexually explicit, pornographic, violent, or otherwise offensive material.</li>
          <li>Engage in scams, fraud, spam, or deceptive practices.</li>
          <li>Interfere with, disrupt, or attempt to compromise the security, integrity, or proper functioning of the App, its services, or its network.</li>
          <li>Engage in any other behavior that violates our Community Guidelines or undermines the safety of the Resumate community.</li>
        </ul>
        <p>
          ResuMate does not pre-screen all user communications or content and is not liable for user-generated language, including offensive, inappropriate, or objectionable words. ResuMate may, but is not obligated to, remove such content. ResuMate has no obligation to monitor user activity or content and does not assume responsibility for such activity or content. Users may report violations, and ResuMate reserves the right to remove content or take enforcement action at its discretion.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>6. Premium Features and Payments</h2>
         <ul className='terms-list'>
          <li>ResuMate may offer optional paid features, such as advanced filters or profile boosts.</li>
          <li>All payments are processed through third-party platforms (e.g., Apple App Store or Google Play).</li>
          <li>Fees are non-refundable except as required by applicable law or platform policies.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>7. Safety, Video Calls, and Real-World Interactions</h2>
        <p>ResuMate is designed with safety-forward features, including a required video call prior to enabling private chat. However:</p>
         <ul className='terms-list'>
          <li>You are solely responsible for your interactions with other users, both online and offline.</li>
          <li>ResuMate does not conduct criminal background checks, identity verification, or user screening, except for optional in-app features explicitly described.</li>
          <li>Any interactions that occur outside of the App, including but not limited to in-person meetings, dates, or communications, are entirely between users and undertaken at their own risk.</li>
          <li>You agree to use your own judgment, discretion, and personal safety precautions when interacting with others, both online and offline.</li>
          <li>ResuMate does not provide relationship, psychological, legal, or professional advice. Any decisions you make based on information obtained through the App are made at your own discretion and risk.</li>
          <li>ResuMate is not responsible or liable for the conduct of any user or for any injury, harm, loss, damages, or disputes arising from interactions between users outside the App.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>8. Intellectual Property</h2>
         <ul className='terms-list'>
          <li>All rights, title, and interest in the App, including its design, features, trademarks, and underlying technology, are owned by ResuMate or its licensors.</li>
          <li>You may not copy, modify, distribute, sell, lease, or reverse-engineer any part of the App.</li>
          <li>You retain ownership of the content you create (e.g., profile responses, uploaded photos), but you grant Resumate a limited license to use it for providing the service.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>9. Account Termination</h2>
         <ul className='terms-list'>
          <li>You may delete your account at any time through the App.</li>
          <li>ResuMate may suspend or terminate your account if you violate these Terms, Community Guidelines, or applicable law.</li>
          <li>Termination may result in loss of access to your account and associated data.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>10. Disclaimer of Warranties and Limitation of Liability</h2>
         <ul className='terms-list'>
          <li>The App is provided “as is” without warranties of any kind.</li>
          <li>ResuMate does not guarantee matches, compatibility, or uninterrupted service.</li>
          <li>To the maximum extent permitted by law, ResuMate disclaims all liability for damages arising from your use of the App or interactions with other users, including offline or real-world interactions.</li>
          <li>ResuMate is not responsible for any loss of data, content, messages, or user information, whether due to technical failure, maintenance, or termination of accounts.</li>
          <li>ResuMate is not responsible or liable for any user-generated content, including messages or communications that contain offensive, abusive, profane, explicit, or inappropriate language.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>11. Indemnification</h2>
        <p>
          You agree to indemnify and hold harmless ResuMate, its affiliates, officers, employees, and agents from any claims, damages, losses, or expenses arising out of your use of the App or violation of these Terms.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>12. Governing Law</h2>
        <p>
          These Terms are governed by the laws of the State of Arizona, USA, without regard to conflict-of-law principles.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>13. Changes to These Terms</h2>
        <p>
          ResuMate may update these Terms from time to time. Material changes will be communicated through the App or by email. Continued use of the App constitutes acceptance of the updated Terms.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>14. Automatic Renewal of Subscriptions</h2>
        <p>
          Paid subscriptions automatically renew unless canceled through your app store settings before the end of the billing period. Access remains active until the current period expires.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>15. Dispute Resolution and Arbitration</h2>
        <p><strong>a. Agreement to Arbitrate</strong></p>
        <p>Except where prohibited by law, you and Resumate agree that any dispute, claim, or controversy arising out of or relating to these Terms or your use of the App will be resolved by binding arbitration, not in court.</p>
        <p><strong>b. Exceptions</strong></p>
        <p>This arbitration requirement does not apply to small claims cases, or to claims relating to intellectual property rights.</p>
        <p><strong>c. Individual Basis</strong></p>
        <p>Arbitration will be conducted on an individual basis. You agree not to bring claims as a plaintiff or class member in any class action, consolidated action, or representative proceeding.</p>
        <p><strong>d. Waiver of Jury Trial</strong></p>
        <p>By agreeing to arbitration, you and Resumate each waive the right to a trial by jury.</p>
        <p><strong>e. Opt-Out Right</strong></p>
        <p>You may opt out of this arbitration agreement by sending written notice to [info@resumate.org] within 30 days of creating your account. If you opt out, disputes may be resolved in court under Section 12 (Governing Law).</p>
      </article>

      <article>
        <h2 className='inner-heading'>16. Monitoring and Enforcement</h2>
        <p>
          Resumate uses a combination of automated tools, user reports, and human moderators to monitor accounts and content for violations of these Terms and our Community Guidelines. We reserve the right, at our sole discretion, to:
        </p>
         <ul className='terms-list'>
          <li>Suspend, limit, or terminate your account.</li>
          <li>Restrict or block access to the App.</li>
          <li>Remove content that violates these Terms or is harmful to the community.</li>
          <li>Use technical, operational, or legal measures to enforce these Terms, including blocking certain IP addresses or devices.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>17. Privacy</h2>
        <p>
          Your use of Resumate is also governed by our Privacy Policy, which explains how we collect, use, and share your personal information. By using the App, you agree that we may process your data in accordance with that policy. We encourage you to review the Privacy Policy carefully to understand our practices.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>18. Severability</h2>
        <p>
          If any provision of these Terms is held invalid or unenforceable, the remaining provisions will remain in full force and effect.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>19. Force Majeure</h2>
        <p>
          ResuMate shall not be liable for any delay, interruption, or failure to perform resulting from causes beyond its reasonable control, including but not limited to acts of God, natural disasters, fires, floods, earthquakes, pandemics, government actions, labor disputes, power failures, internet or network outages, third-party service failures, App Store or platform disruptions, or failures of hosting or cloud service providers.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>20. Entire Agreement</h2>
        <p>
          These Terms, together with the Privacy Policy and Community Guidelines, constitute the entire agreement between you and ResuMate.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>21. Contact Information</h2>
        <p>
          Sparkle from Within LLC<br />
          4539 N 22nd St, Ste N, Phoenix, AZ 85016<br />
          <a className='email' href="mailto:info@resumate.org">info@resumate.org</a>
        </p>
      </article>

      <footer className="terms-footer">
        © 2026 ResuMate. All rights reserved.
      </footer>
      </div>
    </main>

      {/* Footer */}
      <section className={styles.footer}>
        <div className={`container ${styles.container}`}>
          <div className="row">
            <div className="col-sm-4">
              <div className={styles.footerLeft}>
                <a href=""><img src={window.getPublicUrl("/images/footer-logo.svg")} /></a>
              </div>
                      <div className={`${styles.footerMid} ${styles.right}`}>
                <h4>Follow us</h4>
                 <ul className='terms-list'>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social1.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social2.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social3.svg")} /></a></li>
                </ul>
              </div>

            </div>
            <div className="col-sm-4">
                      <div>
                <ul className={styles.termsConditonList}>
                  <li><Link to="/terms&condition">Terms & Conditions</Link></li>
                  <li><Link to="/privacyPolicy">Privacy Policy</Link></li>
                  <li><Link to="/communityGuidelines">Community Guidelines</Link></li>
                  <li><Link to="/eula">EULA</Link></li>
                  <li><Link to="/safety">Safety</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-sm-4">
                  <div className={styles.footerMid}>
                <h4 className="text-right">Get the app</h4>
                <ul className="text-right">
                  <li><a href="https://apps.apple.com/us/app/resumate-app/id6754164064
"><img src={window.getPublicUrl("/images/app2.svg")} /></a></li>
                  <li><a href="https://play.google.com/store/apps/details?id=com.resumate"><img src={window.getPublicUrl("/images/goog2.svg")} /></a></li>                </ul>
              </div>

            </div>
            <div className="col-sm-12">
              <h5>Copyright © 2026 ResuMate.  All rights reserved.</h5>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TermsAndConditions;
